import {
  ParentUser,
  UserStatus,
  ParentRelation,
  UsersSummary,
  MeetingType,
  MeetingStatus,
} from '../../apis/users/users.api.interfaces';

export const mockParentUsers: ParentUser[] = [
  {
    id: 'parent-1',
    firstName: 'Rajesh',
    lastName: 'Sharma',
    email: 'rajesh.sharma@email.com',
    phone: '+91-9876543210',
    profilePicture: '',
    status: UserStatus.ACTIVE,
    createdDate: '2023-09-15',
    lastActive: '2024-01-15',
    relation: ParentRelation.FATHER,
    occupation: 'Software Engineer',
    workPhone: '+91-9876543211',
    emergencyContact: true,
    children: [
      {
        studentId: 'STU001',
        studentName: 'Arjun Sharma',
        grade: '10',
        section: 'A',
      },
    ],
    meetingHistory: [
      {
        id: 'meeting-1',
        date: '2024-01-10',
        type: MeetingType.PARENT_TEACHER,
        teacher: 'Mrs. Priya Gupta',
        subject: 'Mathematics Performance Review',
        notes:
          'Arjun is performing exceptionally well in mathematics. Discussed advanced course options.',
        status: MeetingStatus.COMPLETED,
      },
      {
        id: 'meeting-2',
        date: '2024-01-20',
        type: MeetingType.ACADEMIC,
        teacher: 'Mr. Rajesh Kumar',
        subject: 'Science Project Discussion',
        notes:
          'Upcoming science fair project planning and resource requirements.',
        status: MeetingStatus.SCHEDULED,
      },
    ],
    communicationPreferences: {
      email: true,
      sms: true,
      phone: false,
      push: true,
    },
    address: {
      street: '123 MG Road',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560001',
      country: 'India',
    },
    notes: 'Very supportive parent, always available for school activities.',
  },
  {
    id: 'parent-2',
    firstName: 'Sunita',
    lastName: 'Patel',
    email: 'sunita.patel@email.com',
    phone: '+91-9876543220',
    status: UserStatus.ACTIVE,
    createdDate: '2023-08-20',
    lastActive: '2024-01-14',
    relation: ParentRelation.MOTHER,
    occupation: 'Doctor',
    workPhone: '+91-9876543221',
    emergencyContact: true,
    children: [
      {
        studentId: 'STU002',
        studentName: 'Priya Patel',
        grade: '9',
        section: 'B',
      },
    ],
    meetingHistory: [
      {
        id: 'meeting-3',
        date: '2024-01-08',
        type: MeetingType.DISCIPLINARY,
        teacher: 'Dr. Vikram Rao',
        subject: 'Behavioral Concerns',
        notes: 'Discussed strategies to improve classroom behavior and focus.',
        status: MeetingStatus.COMPLETED,
      },
    ],
    communicationPreferences: {
      email: true,
      sms: false,
      phone: true,
      push: false,
    },
    address: {
      street: '456 Brigade Road',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560025',
      country: 'India',
    },
    notes:
      'Medical professional, prefers phone communication during emergencies.',
  },
  {
    id: 'parent-3',
    firstName: 'Mohammad',
    lastName: 'Khan',
    email: 'mohammad.khan@email.com',
    phone: '+91-9876543230',
    status: UserStatus.PENDING,
    createdDate: '2024-01-10',
    lastActive: '2024-01-12',
    relation: ParentRelation.GUARDIAN,
    occupation: 'Business Owner',
    emergencyContact: false,
    children: [
      {
        studentId: 'STU005',
        studentName: 'Vikash Kumar',
        grade: '8',
        section: 'B',
      },
    ],
    meetingHistory: [],
    communicationPreferences: {
      email: true,
      sms: true,
      phone: true,
      push: true,
    },
    address: {
      street: '789 Commercial Street',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560012',
      country: 'India',
    },
    notes: 'New guardian registration pending document verification.',
  },
  {
    id: 'parent-4',
    firstName: 'Lakshmi',
    lastName: 'Reddy',
    email: 'lakshmi.reddy@email.com',
    phone: '+91-9876543240',
    status: UserStatus.ACTIVE,
    createdDate: '2023-06-10',
    lastActive: '2024-01-16',
    relation: ParentRelation.MOTHER,
    occupation: 'Teacher',
    workPhone: '+91-9876543241',
    emergencyContact: true,
    children: [
      {
        studentId: 'STU004',
        studentName: 'Ananya Reddy',
        grade: '12',
        section: 'A',
      },
    ],
    meetingHistory: [
      {
        id: 'meeting-4',
        date: '2024-01-05',
        type: MeetingType.ACADEMIC,
        teacher: 'Dr. Vikram Rao',
        subject: 'College Preparation Discussion',
        notes:
          'Discussed college entrance exam preparation and career guidance options.',
        status: MeetingStatus.COMPLETED,
      },
      {
        id: 'meeting-5',
        date: '2024-01-18',
        type: MeetingType.GENERAL,
        teacher: 'Ms. Sarah Johnson',
        subject: 'Leadership Development',
        notes: "Ananya's role as Head Girl and leadership responsibilities.",
        status: MeetingStatus.COMPLETED,
      },
    ],
    communicationPreferences: {
      email: true,
      sms: true,
      phone: true,
      push: true,
    },
    address: {
      street: '321 Koramangala',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560034',
      country: 'India',
    },
    notes: 'Fellow educator, very engaged in school activities and committees.',
  },
];

export const mockParentUsersSummary: UsersSummary = {
  totalUsers: 4,
  activeUsers: 3,
  pendingUsers: 1,
  blockedUsers: 0,
  recentlyAdded: 1,
  statusDistribution: {
    active: 3,
    inactive: 0,
    pending: 1,
    blocked: 0,
  },
};
